import getScenarioStore from '../selectors/getScenarioStore';
import { orchestrator } from 'satcheljs';
import { updateIsSuggestionSetCompleteInternal } from '../actions/internalActions';
import { updateIsSuggestionSetComplete } from '../actions/publicActions';

export default orchestrator(updateIsSuggestionSetComplete, actionMessage => {
    const scenarioId = actionMessage.scenarioId;
    const store = getScenarioStore(scenarioId);

    if (store.currentSuggestions) {
        // First, dispatch action to update the store.
        updateIsSuggestionSetCompleteInternal(actionMessage.isComplete, scenarioId);
    }
});
